export default {
  "wrapper": "_wrapper_1i1md_1",
  "wrapperExpanded": "_wrapperExpanded_1i1md_6"
};import "/tmp/202335-27-1rm473z.j6jc.css";